import { StateSchema } from 'app/providers/StoreProvider';

export const getCustomLists = (state: StateSchema) =>
    state.customList?.lists ?? [];

export const getCustomListsLoading = (state: StateSchema) =>
    state.customList?.isListsLoading ?? false;

export const getCustomListsError = (state: StateSchema) =>
    state.customList?.listsError;

export const getCustomListDetail = (state: StateSchema) =>
    state.customList?.detail ?? null;

export const getCustomListDetailLoading = (state: StateSchema) =>
    state.customList?.isDetailLoading ?? false;

export const getCustomListDetailError = (state: StateSchema) =>
    state.customList?.detailError;

export const getCustomListSelectedId = (state: StateSchema) =>
    state.customList?.selectedListId;

export const getCustomListIsManaging = (state: StateSchema) =>
    state.customList?.isManaging ?? false;

export const getCustomListManageError = (state: StateSchema) =>
    state.customList?.manageError;
